import {Flex, Icon, Text, Tooltip, useDisclosure} from '@chakra-ui/react'
import ExamModal from '@pages/ExamPage/components/ExamModal'
import {ReactComponent as ArrowRight} from '@assets/svgs/exam/arrow-right.svg'
import {useNavigate} from 'react-router-dom'
import {PATH} from '@utils/Const'
import {useDispatch} from 'react-redux'
import {
  updateEntryPointShowUpgradeModal,
  updateIsShowUpgradeModal,
} from '@redux/map/mapSlice'

const ExamItem = ({data, type, setName}: any) => {
  const {isOpen, onOpen, onClose} = useDisclosure()
  const navigate = useNavigate()
  const dispatch: any = useDispatch()

  const handleClick = () => {
    if (type === 'LEARN') {
      navigate(PATH.LESSON_LEARN, {
        state: {
          feature: 'FORECAST_SET',
          thumbnail: null,
          topic: data?.title_en,
          title: setName,
        },
      })
    } else {
      if (data?.is_lock) {
        dispatch(updateIsShowUpgradeModal(true))
        dispatch(updateEntryPointShowUpgradeModal('exam-page'))
        return
      }
      onOpen()
    }
  }
  return (
    <Flex
      cursor={'pointer'}
      w={'100%'}
      borderBottom={'1px solid #D9D9D9'}
      _hover={{bg: '#ccc'}}
      onClick={handleClick}>
      <Flex
        py={{base: '16px', md: '24px'}}
        flex={1}
        gap={{base: '16px', md: '24px'}}
        alignItems={'center'}>
        <Tooltip
          color={'#000000'}
          bg={'#ffffff'}
          label={data?.title_en}
          placement="bottom"
          openDelay={200}>
          <Text
            className="line-clamp-1"
            flex={1}
            textOverflow={'ellipsis'}
            overflow={'hidden'}
            color={'rgba(0, 0, 0, 0.85)'}
            fontSize={{base: '14px', md: '18px'}}
            fontWeight={600}>
            {data?.title_en}
          </Text>
        </Tooltip>
        <Text
          flex={1}
          color={data?.band ? 'rgba(24, 144, 255, 1)' : 'rgba(0, 0, 0, 0.45)'}
          fontWeight={600}
          fontSize={{base: 12, md: '18px'}}>
          BAND:{data?.band || '--'}
        </Text>
        <Icon
          w={{base: '20px', md: '24px'}}
          h={{base: '20px', md: '24px'}}
          sx={{
            stroke: '#1890FF',
          }}>
          <ArrowRight />
        </Icon>
      </Flex>
      <ExamModal isOpen={isOpen} onClose={onClose} testId={data?.test_id} />
    </Flex>
  )
}

export default ExamItem
